import { Component, Output, OnInit, EventEmitter } from '@angular/core';
import { Routes, RouterModule, ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular2-notifications';
import { ProgramService } from '../../../../services/program.service';
import { FeesService } from '../../../../fees.service';
import { Fees } from '../../../../models/fees/fees';
import { FeeColumnFilterPanelService } from '../../../../services/fee-column-filter-panel.service';
import { EarlyBirdDiscountCodeService } from '../../../../services/early-bird-discount-code.service';
import { SiblingDiscountService } from '../../../../services/sibling-discount.service';
import { CodeDiscountService } from '../../../../services/code-discount.service';
import { FinancialsService } from '../../../../services/financials.service';
import { StorageUtil } from '../../../../store';

@Component({
  selector: 'app-tryout-fee-listing',
  templateUrl: './tryout-fee-listing.component.html',
  styleUrls: ['./tryout-fee-listing.component.css']
})
export class TryoutFeeListingComponent implements OnInit {
  @Output() childEvent = new EventEmitter<any>();
  @Output() discountFlyoutMenuEvent = new EventEmitter();

  public CodeDiscountForm: FormGroup;
  public SiblingDiscountForm: FormGroup;
  public EarlyBirdDiscountForm: FormGroup;

  public isVisibleRedeemBy = false;
  public isVisibleTotalNoOfTimesCodeInput = false;
  public is_show_visible_column_panel = false;
  public is_show_flyout_content = false;
  public is_show_filter_colomn_content = false;
  public new_column_obj;
  public fees: Fees[];
  public selectedAll: any;
  public selectedRecordIndex = [];
  public isSelectAllCheckBox = false;
  public isCheckAllCheckBox = false;
  public col_key;

  public is_checked_age_range_filter = true;
  public is_checked_waitList_filter = true;
  public is_checked_fee_collected_filter = true;
  public is_checked_gender_filter = true;
  public is_checked_max_players_filter = true;
  public is_checked_payments_structure_filter = true;
  public is_checked_players_registered_filter = true;
  public is_checked_grade_filter = true;

  public programId: number;

  public NoOfTotalIncome: number;
  public NoOfTodayIncome: number;
  public NoOfThisMonthIncome: number;

  public NoOfSelectedFees;
  public isOpenConfirmDeletePopup = false;
  public isConfirmWarning = false;
  public routeParams;

  public currencyOptions = {
    'align': 'left',
    'allowNegative ': false,
    'decimal': '.',
    'precision': 2,
    'prefix': '$ ',
    'thousands': ','
  };


  public setupTooltipOptions = {
    'placement': 'right',
    'show-delay': 0,
    'hide-delay': 0,
    'hide-delay-mobile': 1500,
    'display': true,
    'display-mobile': true,
    'z-index': 0,
    'trigger': 'hover',
    // 'tooltip-class': 'tgs-tooltip',
    'animation-duration': 30,
    'theme': 'dark',
    'shadow': true,
    'offset': 8
  };

  // Source for get index position reset column
  public clubFeeColumnIndex = [
    { 'column_index': 0 },
    { 'column_index': 1 },
    { 'column_index': 2 },
    { 'column_index': 3 },
    { 'column_index': 4 },
    { 'column_index': 5 },
    { 'column_index': 6 },
    { 'column_index': 7 },
    { 'column_index': 8 }
  ];

  public clubFeeColumns = [
    { 'column_index': 0, 'key': 'programName', 'value': 'fee name' },
    { 'column_index': 1, 'key': 'gender', 'value': 'Gender' },
    { 'column_index': 2, 'key': 'ageRange', 'value': 'Age Range' },
    { 'column_index': 3, 'key': 'maxPlayers', 'value': 'Max Players' },
    { 'column_index': 4, 'key': 'waitlistvalue', 'value': 'Waitlist' },
    { 'column_index': 5, 'key': 'playerRegistered', 'value': 'Registrants' },
    { 'column_index': 6, 'key': 'paymentStructure', 'value': 'Payment Structure' },
    { 'column_index': 7, 'key': 'feesCollected', 'value': 'Fees Collected' },
    { 'column_index': 8, 'key': 'grade', 'value': 'Grade' },
  ];

  public errorCodeDiscount = {
    'CodeNamwRequired': 'This field is required.',
    'CodeDiscountPercentageRequired': 'This field is required.',
    'CodeDiscountAmountRequired': 'This field is required.',
  };

  public errorSiblingDiscount = {
    'SecondChildPercentageDiscountRequired': 'This field is required.',
    'ThirdChildPercentageDiscountRequired': 'This field is required.',
    'FourhChildPercentageDiscountRequired': 'This field is required.',
    'FifthChildPercentageDiscountRequired': 'This field is required.',
    'SecondChildFixedAmountDiscountRequired': 'This field is required.',
    'ThirdChildFixedAmountDiscountRequired': 'This field is required.',
    'FourhChildFixedAmountDiscountRequired': 'This field is required.',
    'FifthChildFixedAmountDiscountRequired': 'This field is required.',
  };

  public errorEarlyBirdDiscount = {
    'CodeDiscountPercentageEarlyBirdRequired': 'This field is required.',
    'CodeDiscountAmountEarlyBirdRequired': 'This field is required.',
    'DiscountEndsRequired': 'This field is required.',
  };

  public popupConfirmForm: FormGroup;
  public alphaNumericPattern = /^[a-zA-Z ]+$/;

  constructor(private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private notificationsService: NotificationsService,
    private programService: ProgramService,
    private feesService: FeesService,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private earlyBirdDiscountCodeService: EarlyBirdDiscountCodeService,
    private siblingDiscountService: SiblingDiscountService,
    private codeDiscountService: CodeDiscountService,
    private financialsService: FinancialsService
  ) {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
  }

  ngOnInit() {
    this.routeParams = this.activeRoute.snapshot.params;
    this.programId = this.routeParams.id;
    this.getClubProgramIncomeCounter();
    this.getFees();
    localStorage.setItem('fee_column_reset', JSON.stringify(this.clubFeeColumns));
    this.popupConfirmForm = this.fb.group({
      confirm_fee_delete: [null]
    });
    this.initCodeDiscountForm();
    this.initSiblingDiscountForm();
    this.initEarlyBirdDiscountForm();
  }

  initCodeDiscountForm() {
    this.CodeDiscountForm = this.fb.group({
      PercentageOrFixedAmountDiscount: ['', [Validators.required]],
      CodeName: ['', [Validators.required]],
      CodeDiscountPercentage: ['', [Validators.required]],
      CodeDiscountAmount: ['', [Validators.required]],
      LimitTheDateRange: [''],
      RedeemBy: [''],
      LimitTheTotalNumber: [''],
      TheTotalNumber: ['']
    });
  }

  initSiblingDiscountForm() {
    this.SiblingDiscountForm = this.fb.group({
      PercentageOrFixedAmountDiscountSiblingDiscount: ['', [Validators.required]],
      SecondChildPercentageDiscount: ['', [Validators.required]],
      ThirdChildPercentageDiscount: ['', [Validators.required]],
      FourhChildPercentageDiscount: ['', [Validators.required]],
      FifthChildPercentageDiscount: ['', [Validators.required]],
      SecondChildFixedAmountDiscount: ['', [Validators.required]],
      ThirdChildFixedAmountDiscount: ['', [Validators.required]],
      FourhChildFixedAmountDiscount: ['', [Validators.required]],
      FifthChildFixedAmountDiscount: ['', [Validators.required]],
    });
  }

  initEarlyBirdDiscountForm() {
    this.EarlyBirdDiscountForm = this.fb.group({
      PercentageOrFixedAmountDiscountEarlyBird: ['', [Validators.required]],
      CodeDiscountPercentageEarlyBird: ['', [Validators.required]],
      CodeDiscountAmountEarlyBird: ['', [Validators.required]],
      DiscountEnds: ['', [Validators.required]],
    });
  }

  getClubProgramIncomeCounter() {
    let programId = this.routeParams.id;
    this.financialsService.getFinancialsTopFourCounts(programId).subscribe((data: any) => {
      this.NoOfTodayIncome = data.todaysIncome;
      this.NoOfThisMonthIncome = data.thisMonthIncome;
      this.NoOfTotalIncome = data.totalIncome;
    });
    //this.programService.getClubProgramIncomeCount(this.programId).subscribe((data: any) => {
    //  this.NoOfTodayIncome = data.todaysIncome;
    //  this.NoOfThisMonthIncome = data.thisMonthIncome;
    //  this.NoOfTotalIncome = data.totalIncome;            
    //});
  }

  getFees() {
    this.spinnerService.show();
    this.feesService.getFeesData(this.programId).subscribe(data => {
      this.fees = data;
      this.spinnerService.hide();
    });
  }

  filterGridColumns(e) {
    const radix = 10;
    // Add Column
    if (e.target.checked) {
      this.new_column_obj = {};
      this.new_column_obj = {
        'column_index': parseInt(e.target.getAttribute('data-column-index'), radix),
        'key': e.target.getAttribute('data-key'),
        'value': e.target.value
      };
      for (let i = 0; i < this.clubFeeColumnIndex.length; i++) {
        if (this.clubFeeColumnIndex[i].column_index === parseInt(e.target.getAttribute('data-column-index'), radix)) {
          this.clubFeeColumns.splice(parseInt(e.target.getAttribute('data-column-index'), radix), 0, this.new_column_obj);
          break;
        }
      }
    } else {
      // Toggle filter checkbox boolean value.
      if (e.target.getAttribute('data-key') === 'ageRange') {
        this.is_checked_age_range_filter = false;
      } else if (e.target.getAttribute('data-key') === 'waitlistvalue') {
        this.is_checked_waitList_filter = false;
      } else if (e.target.getAttribute('data-key') === 'feesCollected') {
        this.is_checked_fee_collected_filter = false;
      } else if (e.target.getAttribute('data-key') === 'gender') {
        this.is_checked_gender_filter = false;
      } else if (e.target.getAttribute('data-key') === 'maxPlayers') {
        this.is_checked_max_players_filter = false;
      } else if (e.target.getAttribute('data-key') === 'paymentStructure') {
        this.is_checked_payments_structure_filter = false;
      } else if (e.target.getAttribute('data-key') === 'playerRegistered') {
        this.is_checked_players_registered_filter = false;
      } else if (e.target.getAttribute('data-key') === 'grade') {
        this.is_checked_grade_filter = false;
      }
      // Remove column
      for (let i = 0; i < this.clubFeeColumns.length; i++) {
        if (this.clubFeeColumns[i].key && this.clubFeeColumns[i].key === e.target.getAttribute('data-key')) {
          this.clubFeeColumns.splice(i, 1);
          break;
        }
      }
    }
  }

  resetVisibleColumns(event) {
    event.preventDefault();
    this.clubFeeColumns.length = 0;
    this.clubFeeColumns = JSON.parse(localStorage.getItem('fee_column_reset'));
    // Reset filter checkbox
    this.is_checked_age_range_filter = true;
    this.is_checked_waitList_filter = true;
    this.is_checked_fee_collected_filter = true;
    this.is_checked_gender_filter = true;
    this.is_checked_max_players_filter = true;
    this.is_checked_payments_structure_filter = true;
    this.is_checked_players_registered_filter = true;
    this.is_checked_grade_filter = true;
  }

  isShowFlyoutUI() {
    return this.is_show_flyout_content;
  }

  isShowFilterColumnUI() {
    return this.is_show_filter_colomn_content;
  }

  toggleFlyoutOrFilterPanel() {
    if (this.is_show_visible_column_panel) {
      this.is_show_visible_column_panel = false;
    } else {
      this.is_show_visible_column_panel = true;
    }
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(this.is_show_visible_column_panel);
  }

  toggleFilterColumnsPanel(flag) {
    if (flag === 'filter-coloumn-menu') {
      this.is_show_flyout_content = false;
      this.is_show_filter_colomn_content = true;
      this.toggleFlyoutOrFilterPanel();
    } else if (flag === 'discount-flayout-menu') {

      // Validation : Select a fee to add a discount.
      if (this.NoOfSelectedFees > 0) {
        this.is_show_flyout_content = true;
        this.is_show_filter_colomn_content = false;
        this.toggleFlyoutOrFilterPanel();
      } else {
        const toast = this.notificationsService.warn('Warning', 'Please select a fee to add a discount.', {
          timeOut: 3000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false
        });
      }

    } else if (flag === 'close-flayout-menu') {
      this.toggleFlyoutOrFilterPanel();
    }
  }

  SaveColumnFilterPreference(e) {
    e.preventDefault();
    const feeColumnFilterState = [
      { 'is_checked_age_range_filter': this.is_checked_age_range_filter },
      { 'is_checked_auto_billing_filter': this.is_checked_waitList_filter },
      { 'is_checked_fee_collected_filter': this.is_checked_fee_collected_filter },
      { 'is_checked_gender_filter': this.is_checked_gender_filter },
      { 'is_checked_max_players_filter': this.is_checked_max_players_filter },
      { 'is_checked_payments_structure_filter': this.is_checked_payments_structure_filter },
      { 'is_checked_players_registered_filter': this.is_checked_players_registered_filter },
      { 'is_checked_grade_filter': this.is_checked_grade_filter }
    ];
    localStorage.setItem('feeColumnFilterState', JSON.stringify(feeColumnFilterState));
    this.toggleFilterColumnsPanel('filter-coloumn-menu');
  }

  redirectToEditFeePage(fee_id: number, setup: number) {
    const RP = this.activeRoute.snapshot.params;
    if (setup === 1) {
      this.router.navigate(['/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step1/' + fee_id]);
    } else if (setup === 2) {
      this.router.navigate(['/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step2/' + fee_id]);
    } else if (setup === 3) {
      this.router.navigate(['/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step3/' + fee_id]);
    }
  }

  selectedRecord(i, e) {
    if (e.target.checked) {
      this.selectedRecordIndex.push(i);
    } else {
      this.selectedRecordIndex.splice(this.selectedRecordIndex.indexOf(i), 1);
    }
    // For enable status/delete button.
    this.NoOfSelectedFees = this.selectedRecordIndex.length;
  }

  selectAll() {
    if (this.isSelectAllCheckBox) {
      this.isSelectAllCheckBox = false;
      this.isCheckAllCheckBox = false;
      this.selectedRecordIndex.length = 0;
    } else {
      this.isSelectAllCheckBox = true;
      this.isCheckAllCheckBox = true;
      const l = this.fees.length;
      for (let i = 0; i < l; i++) {
        this.selectedRecordIndex.push(this.fees[i].clubProgramFeeID);
      }
    }
    // For enable status/delete button.
    this.NoOfSelectedFees = this.selectedRecordIndex.length;
  }

  addConfirmFormValidation() {
    const control = this.popupConfirmForm.get('confirm_fee_delete');
    control.setValidators(Validators.compose([Validators.required, Validators.pattern(this.alphaNumericPattern)]));
    control.updateValueAndValidity();
  }
  removeConfirmFormValidation() {
    const control = this.popupConfirmForm.get('confirm_fee_delete');
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }

  openPopup() {
    this.isOpenConfirmDeletePopup = true;
    this.addConfirmFormValidation();
  }

  closePopup() {
    this.isConfirmWarning = false;
    this.popupConfirmForm.reset();
    this.isOpenConfirmDeletePopup = false;
    this.removeConfirmFormValidation();
  }

  onPopUpConfirm(formValue) {
    const flag = this.isDeleteTextMatched();
    if (flag) {
      this.isConfirmWarning = false;
      this.closePopup();
      this.deleteFees();
    } else {
      this.isConfirmWarning = true;
    }
  }

  isDeleteTextMatched() {
    const val = this.popupConfirmForm.get('confirm_fee_delete').value;
    if (val) {
      return (val.trim() === 'DELETE') ? true : false;
    }
  }

  isConfirmDeleteValid() {
    return this.popupConfirmForm.get('confirm_fee_delete').errors
      && (this.popupConfirmForm.get('confirm_fee_delete').touched
        || this.popupConfirmForm.get('confirm_fee_delete').dirty);
  }

  validateUi() {
    Object.keys(this.popupConfirmForm.controls).forEach(field => {
      const control = this.popupConfirmForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  removeValidaion(name) {
    const control = this.popupConfirmForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }

  requiredValidaion(name) {
    const control = this.popupConfirmForm.get(name);
    control.reset();
    control.enable();
    control.setValidators([Validators.required]);
    control.updateValueAndValidity();
  }

  deleteSelectedFeeRecords() {
    this.openPopup();
  }

  deleteFees() {
    const l = this.selectedRecordIndex.length;
    const ids = this.selectedRecordIndex.join(', ');
    this.spinnerService.show();
    this.feesService.deleteFees(ids).subscribe((data) => {
      if (l === 1) {
        this.alertMessage('success', 'A Fee successfully deleted.');
      } else {
        this.alertMessage('success', 'Fees successfully deleted.');
      }
      this.NoOfSelectedFees = 0; // Hide status and delete button.
      this.removeValidaion('confirm_fee_delete');
      this.closePopup();
      this.refreshReocrds();
      this.spinnerService.hide();
    }, error => {
      console.log(error);
    });
  }

  alertMessage(status, message) {
    const toast = this.notificationsService.success(status, message, {
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: false
    });
  }

  refreshReocrds() {
    this.getFees();
    this.isSelectAllCheckBox = false;
    this.isCheckAllCheckBox = false;
  }


  /* ==================================== Code Discount ==================================== */
  percentageDiscountSelected() {
    return (!!this.CodeDiscountForm.get('PercentageOrFixedAmountDiscount'))
      && (this.CodeDiscountForm.get('PercentageOrFixedAmountDiscount').value === '1');
  }
  isCodePercentageAmountVisible() {
    return this.percentageDiscountSelected();
  }
  isCodeDiscountAmountVisible() {
    return !this.percentageDiscountSelected();
  }
  percentageOrFixedAmountDiscountChange(event) {
    event.stopPropagation();
    if (this.percentageDiscountSelected()) {
      this.requiredValidaionCodeDiscount('CodeDiscountPercentage');
      this.removeValidaionCodeDiscount('CodeDiscountAmount');
    } else {
      this.requiredValidaionCodeDiscount('CodeDiscountAmount');
      this.removeValidaionCodeDiscount('CodeDiscountPercentage');
    }
  }
  limitTheDateRangeChange(event) {
    event.stopPropagation();
    if (event.target.checked) {
      this.isVisibleRedeemBy = true;
    } else {
      this.isVisibleRedeemBy = false;
    }
  }
  limitTheTotalNumberChange(event) {
    event.stopPropagation();
    if (event.target.checked) {
      this.isVisibleTotalNoOfTimesCodeInput = true;
    } else {
      this.isVisibleTotalNoOfTimesCodeInput = false;
    }
  }
  isPercentageOrFixedAmountDiscountValid() {
    return this.CodeDiscountForm.get('PercentageOrFixedAmountDiscount').errors
      && (this.CodeDiscountForm.get('PercentageOrFixedAmountDiscount').touched
        || this.CodeDiscountForm.get('PercentageOrFixedAmountDiscount').dirty);
  }
  isCodeNameValid() {
    return this.CodeDiscountForm.get('CodeName').errors
      && (this.CodeDiscountForm.get('CodeName').touched
        || this.CodeDiscountForm.get('CodeName').dirty);
  }
  isCodeDiscountPercentageValid() {
    return this.CodeDiscountForm.get('CodeDiscountPercentage').errors
      && (this.CodeDiscountForm.get('CodeDiscountPercentage').touched
        || this.CodeDiscountForm.get('CodeDiscountPercentage').dirty);
  }
  isCodeDiscountAmountValid() {
    return this.CodeDiscountForm.get('CodeDiscountAmount').errors
      && (this.CodeDiscountForm.get('CodeDiscountAmount').touched
        || this.CodeDiscountForm.get('CodeDiscountAmount').dirty);
  }
  validateCodeDiscountUi() {
    Object.keys(this.CodeDiscountForm.controls).forEach(field => {
      const control = this.CodeDiscountForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  removeValidaionCodeDiscount(name) {
    const control = this.CodeDiscountForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }
  requiredValidaionCodeDiscount(name) {
    const control = this.CodeDiscountForm.get(name);
    control.reset();
    control.setValidators([Validators.required]);
    control.updateValueAndValidity();
  }
  resetCodeDiscountForm(name) {
    const control = this.CodeDiscountForm.get(name);
    control.reset();
  }

  submitCodeDiscountForm(e, form) {
    e.stopPropagation();
    if (form.status === 'VALID') {
      const value = form.value;
      const obj = {
        selectedClubProgramFeeIDList: this.selectedRecordIndex,
        clubDiscountTypeID: 1,
        percentageDiscount: Number(value.CodeDiscountPercentage),
        fixedDiscountAmount: Number(value.CodeDiscountAmount),
        discountCode: value.CodeName,
        endDate: value.RedeemBy,
        numberUses: value.TheTotalNumber,
        addedBy: StorageUtil.userID,
      };
      e.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      e.target.disabled = true;
      this.codeDiscountService.create(obj).subscribe((data: any) => {
        e.target.innerHTML = 'Save';
        e.target.disabled = false;

        this.resetCodeDiscountForm('PercentageOrFixedAmountDiscount');
        this.resetCodeDiscountForm('CodeName');
        this.resetCodeDiscountForm('CodeDiscountPercentage');
        this.resetCodeDiscountForm('CodeDiscountAmount');
        this.resetCodeDiscountForm('LimitTheDateRange');
        this.resetCodeDiscountForm('RedeemBy');
        this.resetCodeDiscountForm('LimitTheTotalNumber');
        this.resetCodeDiscountForm('TheTotalNumber');

        this.NoOfSelectedFees = 0;
        this.selectedRecordIndex.length = 0;
        this.isSelectAllCheckBox = false;
        this.isCheckAllCheckBox = false;
        this.alertMessage('success', data.result);
        this.toggleFlyoutOrFilterPanel();
        this.getFees();
      }, error => {
        this.alertMessage('error', error.statusText);
      });
    } else {
      this.validateCodeDiscountUi();
    }
  }


  /* ==================================== Early Bird Discount ==================================== */
  percentageDiscountEarlyBirdSelected() {
    return (!!this.EarlyBirdDiscountForm.get('PercentageOrFixedAmountDiscountEarlyBird'))
      && (this.EarlyBirdDiscountForm.get('PercentageOrFixedAmountDiscountEarlyBird').value === '1');
  }
  isCodePercentageAmountEarlyBirdVisible() {
    return this.percentageDiscountEarlyBirdSelected();
  }
  isCodeDiscountAmountEarlyBirdVisible() {
    return !this.percentageDiscountEarlyBirdSelected();
  }
  percentageOrFixedAmountDiscountEarlyBirdChange(event) {
    event.stopPropagation();
    if (this.percentageDiscountEarlyBirdSelected()) {
      this.requiredValidaionEarlyBirdDiscount('CodeDiscountPercentageEarlyBird');
      this.removeValidaionEarlyBirdDiscount('CodeDiscountAmountEarlyBird');
    } else {
      this.requiredValidaionEarlyBirdDiscount('CodeDiscountAmountEarlyBird');
      this.removeValidaionEarlyBirdDiscount('CodeDiscountPercentageEarlyBird');
    }
  }
  isPercentageOrFixedAmountDiscountEarlyBirdValid() {
    return this.EarlyBirdDiscountForm.get('PercentageOrFixedAmountDiscountEarlyBird').errors
      && (this.EarlyBirdDiscountForm.get('PercentageOrFixedAmountDiscountEarlyBird').touched
        || this.EarlyBirdDiscountForm.get('PercentageOrFixedAmountDiscountEarlyBird').dirty);
  }
  isCodeDiscountPercentageEarlyBirdValid() {
    return this.EarlyBirdDiscountForm.get('CodeDiscountPercentageEarlyBird').errors
      && (this.EarlyBirdDiscountForm.get('CodeDiscountPercentageEarlyBird').touched
        || this.EarlyBirdDiscountForm.get('CodeDiscountPercentageEarlyBird').dirty);
  }
  isCodeDiscountAmountEarlyBirdValid() {
    return this.EarlyBirdDiscountForm.get('CodeDiscountAmountEarlyBird').errors
      && (this.EarlyBirdDiscountForm.get('CodeDiscountAmountEarlyBird').touched
        || this.EarlyBirdDiscountForm.get('CodeDiscountAmountEarlyBird').dirty);
  }
  isDiscountEndsValid() {
    return this.EarlyBirdDiscountForm.get('DiscountEnds').errors
      && (this.EarlyBirdDiscountForm.get('DiscountEnds').touched
        || this.EarlyBirdDiscountForm.get('DiscountEnds').dirty);
  }
  validateEarlyBirdDiscountUi() {
    Object.keys(this.EarlyBirdDiscountForm.controls).forEach(field => {
      const control = this.EarlyBirdDiscountForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  removeValidaionEarlyBirdDiscount(name) {
    const control = this.EarlyBirdDiscountForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }
  requiredValidaionEarlyBirdDiscount(name) {
    const control = this.EarlyBirdDiscountForm.get(name);
    control.reset();
    control.setValidators([Validators.required]);
    control.updateValueAndValidity();
  }
  resetEarlyBirdDiscountForm(name) {
    const control = this.EarlyBirdDiscountForm.get(name);
    control.reset();
  }
  submitEarlyBirdDiscount(e, form) {
    e.stopPropagation();
    if (form.status === 'VALID') {
      const value = form.value;
      const obj = {
        selectedClubProgramFeeIDList: this.selectedRecordIndex,
        clubDiscountTypeID: 3,
        percentageDiscount: Number(value.CodeDiscountPercentageEarlyBird),
        fixedDiscountAmount: Number(value.CodeDiscountAmountEarlyBird),
        endDate: value.DiscountEnds,
        addedBy: StorageUtil.userID,
      };
      e.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      e.target.disabled = true;
      this.earlyBirdDiscountCodeService.create(obj).subscribe((data: any) => {
        e.target.innerHTML = 'Save';
        e.target.disabled = false;
        this.resetEarlyBirdDiscountForm('CodeDiscountAmountEarlyBird');
        this.resetEarlyBirdDiscountForm('CodeDiscountPercentageEarlyBird');
        this.resetEarlyBirdDiscountForm('PercentageOrFixedAmountDiscountEarlyBird');
        this.resetEarlyBirdDiscountForm('DiscountEnds');
        this.NoOfSelectedFees = 0;
        this.selectedRecordIndex.length = 0;
        this.isSelectAllCheckBox = false;
        this.isCheckAllCheckBox = false;
        this.alertMessage('success', data.result);
        this.toggleFlyoutOrFilterPanel();
        this.getFees();
      }, error => {
        this.alertMessage('error', error.statusText);
      });
    } else {
      this.validateEarlyBirdDiscountUi();
    }
  }


  /* ==================================== Sibling Discount ==================================== */
  percentageDiscountSiblingSelected() {
    return (!!this.SiblingDiscountForm.get('PercentageOrFixedAmountDiscountSiblingDiscount'))
      && (this.SiblingDiscountForm.get('PercentageOrFixedAmountDiscountSiblingDiscount').value === '1');
  }
  isCodePercentageAmountSiblingVisible() {
    return this.percentageDiscountSiblingSelected();
  }
  isCodeDiscountAmountSiblingVisible() {
    return !this.percentageDiscountSiblingSelected();
  }
  percentageOrFixedAmountDiscountSiblingDiscountChange(event) {
    event.stopPropagation();
    if (this.percentageDiscountSiblingSelected()) {
      this.requiredValidaionSiblingDiscount('SecondChildPercentageDiscount');
      this.requiredValidaionSiblingDiscount('ThirdChildPercentageDiscount');
      this.requiredValidaionSiblingDiscount('FourhChildPercentageDiscount');
      this.requiredValidaionSiblingDiscount('FifthChildPercentageDiscount');
      this.removeValidaionSiblingDiscount('SecondChildFixedAmountDiscount');
      this.removeValidaionSiblingDiscount('ThirdChildFixedAmountDiscount');
      this.removeValidaionSiblingDiscount('FourhChildFixedAmountDiscount');
      this.removeValidaionSiblingDiscount('FifthChildFixedAmountDiscount');
    } else {
      this.requiredValidaionSiblingDiscount('SecondChildFixedAmountDiscount');
      this.requiredValidaionSiblingDiscount('ThirdChildFixedAmountDiscount');
      this.requiredValidaionSiblingDiscount('FourhChildFixedAmountDiscount');
      this.requiredValidaionSiblingDiscount('FifthChildFixedAmountDiscount');
      this.removeValidaionSiblingDiscount('SecondChildPercentageDiscount');
      this.removeValidaionSiblingDiscount('ThirdChildPercentageDiscount');
      this.removeValidaionSiblingDiscount('FourhChildPercentageDiscount');
      this.removeValidaionSiblingDiscount('FifthChildPercentageDiscount');
    }
  }
  isSecondChildPercentageDiscountValid() {
    return this.SiblingDiscountForm.get('SecondChildPercentageDiscount').errors
      && (this.SiblingDiscountForm.get('SecondChildPercentageDiscount').touched
        || this.SiblingDiscountForm.get('SecondChildPercentageDiscount').dirty);
  }
  isThirdChildPercentageDiscountValid() {
    return this.SiblingDiscountForm.get('ThirdChildPercentageDiscount').errors
      && (this.SiblingDiscountForm.get('ThirdChildPercentageDiscount').touched
        || this.SiblingDiscountForm.get('ThirdChildPercentageDiscount').dirty);
  }
  isFourhChildPercentageDiscountValid() {
    return this.SiblingDiscountForm.get('FourhChildPercentageDiscount').errors
      && (this.SiblingDiscountForm.get('FourhChildPercentageDiscount').touched
        || this.SiblingDiscountForm.get('FourhChildPercentageDiscount').dirty);
  }
  isFifthChildPercentageDiscountValid() {
    return this.SiblingDiscountForm.get('FifthChildPercentageDiscount').errors
      && (this.SiblingDiscountForm.get('FifthChildPercentageDiscount').touched
        || this.SiblingDiscountForm.get('FifthChildPercentageDiscount').dirty);
  }
  isSecondChildFixedAmountDiscountValid() {
    return this.SiblingDiscountForm.get('SecondChildFixedAmountDiscount').errors
      && (this.SiblingDiscountForm.get('SecondChildFixedAmountDiscount').touched
        || this.SiblingDiscountForm.get('SecondChildFixedAmountDiscount').dirty);
  }
  isThirdChildFixedAmountDiscountValid() {
    return this.SiblingDiscountForm.get('ThirdChildFixedAmountDiscount').errors
      && (this.SiblingDiscountForm.get('ThirdChildFixedAmountDiscount').touched
        || this.SiblingDiscountForm.get('ThirdChildFixedAmountDiscount').dirty);
  }
  isFourhChildFixedAmountDiscountValid() {
    return this.SiblingDiscountForm.get('FourhChildFixedAmountDiscount').errors
      && (this.SiblingDiscountForm.get('FourhChildFixedAmountDiscount').touched
        || this.SiblingDiscountForm.get('FourhChildFixedAmountDiscount').dirty);
  }
  isFifthChildFixedAmountDiscountValid() {
    return this.SiblingDiscountForm.get('FifthChildFixedAmountDiscount').errors
      && (this.SiblingDiscountForm.get('FifthChildFixedAmountDiscount').touched
        || this.SiblingDiscountForm.get('FifthChildFixedAmountDiscount').dirty);
  }
  isPercentageOrFixedAmountDiscountSiblingValid() {
    return this.SiblingDiscountForm.get('PercentageOrFixedAmountDiscountSiblingDiscount').errors
      && (this.SiblingDiscountForm.get('PercentageOrFixedAmountDiscountSiblingDiscount').touched
        || this.SiblingDiscountForm.get('PercentageOrFixedAmountDiscountSiblingDiscount').dirty);
  }

  validateSiblingDiscountUi() {
    Object.keys(this.SiblingDiscountForm.controls).forEach(field => {
      const control = this.SiblingDiscountForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  removeValidaionSiblingDiscount(name) {
    const control = this.SiblingDiscountForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }
  requiredValidaionSiblingDiscount(name) {
    const control = this.SiblingDiscountForm.get(name);
    control.reset();
    control.setValidators([Validators.required]);
    control.updateValueAndValidity();
  }
  resetSiblingDiscountForm(name) {
    const control = this.SiblingDiscountForm.get(name);
    control.reset();
  }

  submitSiblingDiscount(e, form) {
    e.stopPropagation();
    if (form.status === 'VALID') {
      const value = form.value;
      const obj = {
        selectedClubProgramFeeIDList: this.selectedRecordIndex,
        clubDiscountTypeID: 2,
        secondChildPercent: Number(value.SecondChildPercentageDiscount),
        thirdChildPercent: Number(value.ThirdChildPercentageDiscount),
        fourthChildPercent: Number(value.FourhChildPercentageDiscount),
        fifthChildPercent: Number(value.FifthChildPercentageDiscount),
        secondChildFixedAmount: Number(value.SecondChildFixedAmountDiscount),
        thirdChildFixedAmount: Number(value.ThirdChildFixedAmountDiscount),
        fourthChildFixedAmount: Number(value.FourhChildFixedAmountDiscount),
        fifthChildFixedAmount: Number(value.FifthChildFixedAmountDiscount),
        addedBy: StorageUtil.userID,
      };
      e.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      e.target.disabled = true;
      this.siblingDiscountService.create(obj).subscribe((data: any) => {
        e.target.innerHTML = 'Save';
        e.target.disabled = false;
        this.resetSiblingDiscountForm('PercentageOrFixedAmountDiscountSiblingDiscount');
        this.resetSiblingDiscountForm('SecondChildPercentageDiscount');
        this.resetSiblingDiscountForm('ThirdChildPercentageDiscount');
        this.resetSiblingDiscountForm('FourhChildPercentageDiscount');
        this.resetSiblingDiscountForm('FifthChildPercentageDiscount');
        this.resetSiblingDiscountForm('SecondChildFixedAmountDiscount');
        this.resetSiblingDiscountForm('ThirdChildFixedAmountDiscount');
        this.resetSiblingDiscountForm('FourhChildFixedAmountDiscount');
        this.resetSiblingDiscountForm('FifthChildFixedAmountDiscount');
        this.NoOfSelectedFees = 0;
        this.selectedRecordIndex.length = 0;
        this.isSelectAllCheckBox = false;
        this.isCheckAllCheckBox = false;
        this.alertMessage('success', data.result);
        this.toggleFlyoutOrFilterPanel();
        this.getFees();
      }, error => {
        this.alertMessage('error', error.statusText);
      });
    } else {
      this.validateSiblingDiscountUi();
    }
  }

  // TODO: create custom tooltip.
  feeStatusTooltip(setup) {
    const str = 'Basic Fee Info';
    const str2 = 'Billing Information';
    const str3 = 'Payment Structure/Plans';
    return str3;
  }

  convertInCurrency(val, controlName, formName) {
    let newVal = '';

    // const regex = /^[0-9 \-]+$/;
    // if (!regex.test(val)) {
    //  e.preventDefault();
    // }

    if (val !== '') {
      const radix = 10;
      const strVal = val.replace(/\.,/g, '');
      const intVal = parseInt(strVal, radix);
      const decVal = intVal / 100;
      newVal = decVal.toLocaleString('en-US', { minimumFractionDigits: 2 });
    } else {
      newVal = '';
    }

    if (formName === 'CodeDiscountForm') {
      this.CodeDiscountForm.controls[controlName].patchValue(newVal);
    } else if (formName === 'EarlyBirdDiscountForm') {
      this.EarlyBirdDiscountForm.controls[controlName].patchValue(newVal);
    } else if (formName === 'SiblingDiscountForm') {
      this.SiblingDiscountForm.controls[controlName].patchValue(newVal);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-fee/tryout-fee-listing/tryout-fee-listing.component.ts